import { Inline } from '@/design-system/inline/inline';
import { Separator } from '@/design-system/separator/separator';
import { Stack } from '@/design-system/stack/stack';
import { tw } from '@/utils/tw';

type ReturnsBreakdownProps = {
  returnLabel: string;
  grossReturn: string;
  feeLabel: string;
  feesAmount: string;
  netReturn: string;
};

export const ReturnsBreakdown = ({
  returnLabel,
  grossReturn,
  feeLabel,
  feesAmount,
  netReturn,
}: ReturnsBreakdownProps) => {
  return (
    <Stack space={3} className="w-full">
      <BreakDownItem label={returnLabel} value={grossReturn} />

      <Separator />

      <BreakDownItem label={feeLabel} value={feesAmount} />

      <Separator />

      <BreakDownItem label="Net returns" value={netReturn} />
    </Stack>
  );
};

type BreakDownItemProps = {
  label: string;
  value: string;
};

const BreakDownItem = ({ label, value }: BreakDownItemProps) => {
  const breakdownItemClassName = tw`text-sm font-normal text-foreground`;

  return (
    <Inline justify="between" wrap="nowrap" className="w-full">
      <p className={breakdownItemClassName}>{label}</p>

      <p className={breakdownItemClassName}>{value}</p>
    </Inline>
  );
};
